import { Link } from "react-router-dom";
import { useTeam } from "./team-members/team-member-context";
import Logout from "./third-party/auth/logout";

const TeamDinamicsEntries = () => {
  return (
    <div className="flex">
      <Link to="/team">See my team</Link>
      <Link className="pl-5" to="/facilitator">Facilitator</Link>
      <Link className="pl-5" to="/pair-matrix">Pair Matrix</Link>
      <Link className="pl-5" to="/speed-back">SpeedBack</Link>
      <div className="pl-5">
        <Logout className="uppercase" />
      </div>
    </div>
  )
}

export default function Layout({ children }: any) {
  return (
    <div className="container">
      <div className="p-5">
        <TeamDinamicsEntries />

        { children }
      </div>
    </div>
  )
}

export function LayoutWithTeamExistanceChecker({ children }: any) {
  const { teamMembers } = useTeam();

  return (
    <div className="container">
      <div className="p-5">
        <TeamDinamicsEntries />

        {teamMembers.length === 0 ? <p className="pt-4">Your team is empty. <Link to="/" className="font-bold">Create your team now</Link> </p> : children}
      </div>
    </div>
  )
}